import React from "react";

import { CMC_PH_TYPE, CMC_SOIL_TYPE, CROP_ROTATION, GOAL_LEVEL_2 } from "models";

import { CheckboxSegmented, Flex } from "components";

type CropMixComposerGoalMultiSelectItemProps = {
  items: { name: string; value: string }[];
  selectedItems: string[];
  onSelectionChanged: (selectedItem: GOAL_LEVEL_2 | CMC_SOIL_TYPE | CMC_PH_TYPE | CROP_ROTATION) => void;
  disabledOptions?: string[];
  dataTestId?: string;
};

export const CropMixComposerMultiSelect = ({
  items,
  selectedItems,
  onSelectionChanged,
  disabledOptions,
  dataTestId,
}: CropMixComposerGoalMultiSelectItemProps) => (
  <Flex className="crop-mix-composer-goal-multi-select-item" gap={"0.5rem"} wrap="wrap" align="center">
    {items.map((option, index) => {
      const isSelected = selectedItems.includes(option.value);
      const isDisabled = disabledOptions?.includes(option.value);

      return (
        <CheckboxSegmented
          key={`crop-mix-composer-multiSelect-${index}`}
          checked={isSelected}
          disabled={isDisabled}
          onChange={() => {
            if (isDisabled) return;

            onSelectionChanged(option.value as GOAL_LEVEL_2 | CMC_SOIL_TYPE | CMC_PH_TYPE);
          }}
          data-testid={`crop-mix-composer-multiSelect-${dataTestId}-option-${index}`}
          label={option.name}
        />
      );
    })}
  </Flex>
);
